import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import ReactResizeDetector from 'react-resize-detector';
import { omit } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { getParams } from '../common/utils';
import { popupActions } from '../../store/popupStore';
import { SECTIONS, reportActions } from '../../store/reportStore';
import { writeErr, writeInfo } from '../common/logger';
import { repiActions, reportTypes } from '../../store/repiStore';
import { apiGet, getHostApi, hasPermission } from '../../store/apiWrapper';
import { isNullOrUndefined, isEmpty, capitalize, getLanguage, isString, isRepiWeb } from '../../store/storeFunctions';
import { addConsentToStorage, getReportsAvailability, hasConsentInStorage, isPoolReport, isInvoicesReport } from '../repi/repiUtils';
import RepiSubjectInfo from '../repi/header/repiSubjectInfo';
import RepiSearchManager from '../repi/header/repiSearchManager';
import RepiReportManager from '../repi/header/repiReportManager';

import RepiCz from '../../img/repi/RepiCz';
import RepiEn from '../../img/repi/RepiEn';
import RepiSk from '../../img/repi/RepiSk';

import './headersCommon.scss';
import './repiHeader.scss';
import '../common/reportSelectionMenu.scss';

const REPORT_ORDER = [
    reportTypes.creditPlus,
    reportTypes.creditMinus,
    reportTypes.poolPlus,
    reportTypes.poolMinus,
    reportTypes.subjectPlus,
    reportTypes.invoicesPlus,
    reportTypes.invoicesMinus,
    reportTypes.dataCorrection,
    reportTypes.dataCorrectionInternal
];

const TAB_STYLE = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
};

class RepiHeader extends React.Component {
    state = {
        dotOffsetLeft: -1,
        hasControls: false,
        movePos: 0,
        isBeginPos: true,
        isEndPos: false
    };

    get isOnSearchPage() { return this.props.location.pathname.endsWith("/search"); }
    get isOnResultsPage() { return this.isActiveLink("/results"); }
    get isOnReportPage() { return this.isActiveLink("/report"); }
    get repiSettings() { return JSON.parse(localStorage.getItem("auth")).repi }
    get isTinted() { try { return localStorage.locales_tint === "header"; } catch (error) { return false; }}

    render() {
        const { reportType } = this.props.getRepiProps();

        return (
            <>
                <div style={{ top: this.props.user.authentication.limitedUser ? "0px" : null, display: "flex", flexDirection: "row" }}
                    id="repi-header"
                    className={classnames("sr-ribbon is-sticky", {
                        "tinted": this.props.tinted,
                        "shadowed": this.props.shadowed,
                        "hide-on-mobile": (isNullOrUndefined(this.props.isMobile))
                    })}
                >
                    <div className="main-header">
                        <span>
                            {this.isOnReportPage ? <RepiSubjectInfo /> : <div><Translate id="Repi.Header" /></div>}
                        </span>
                    </div>
                    {!this.props.isMobile && <div className="repi-header-right">
                        {hasPermission(null, "REPIDataCorrectionSubjectContributor") && <div className="add-subject-wrapper">
                            <button className={classnames("bb-button small gradient-1", { "is-square": localStorage.locales_button_style === "square" })}
                                onClick={() => this.props.repiRedirect("/add-subject")}>
                                <span><strong><Translate id="Repi.DataCorrection.AddSubject" /></strong></span>
                            </button>
                        </div>}
                        {!isRepiWeb() && <div className="repi-logo">{this.renderRepiLogo()}</div>}
                    </div>}
                </div>
                {!this.props.isMobile && <>
                    {this.renderSubheader()}
                    {this.isOnSearchPage && <RepiSearchManager />}
                    {this.isOnReportPage && <RepiReportManager reportType={reportType} onCalculationDateSubmit={this.onReportRequested} />}
                </>}
            </>
        );
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleWindowResize);
        this.solveControls();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname)
            this.solveControls()
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleWindowResize);
    }

    renderSubheader = () => {
        const reportsAvailability = getReportsAvailability();

        if (isNullOrUndefined(reportsAvailability))
            return null;

        return (
            <>
                {this.renderDotSlider()}
                <ReactResizeDetector handleWidth refreshMode="debounce" refreshRate={500} onResize={this.solveControls} />
                <div className="tabs-subheader-wrapper inherit-background">
                    {this.state.hasControls && <span className={classnames({ "active": !this.state.isBeginPos })} onClick={(e) => this.scroll(e, "left")}>
                        <FontAwesomeIcon icon="angle-left" />
                    </span>}
                    <div className={classnames("tabs tabs-subheader shadowed", { "tinted": this.props.tinted })} ref={el => this.linkRef(el)}>
                        <div className="selection-menu-wrapper">
                            <div className="report-selection-menu inherit-background">
                                {this.renderSearchLinks()}
                                {this.isOnReportPage && <>
                                    <div><span><FontAwesomeIcon icon="angle-right" className="report-selection-menu-separator" /></span></div>
                                    {REPORT_ORDER.map(r => this.renderHeaderReportLink(r, capitalize(r), reportsAvailability))}
                                </>}
                            </div>
                        </div>
                    </div>
                    {this.state.hasControls && <span className={classnames({ "active": !this.state.isEndPos })} onClick={(e) => this.scroll(e, "right")}>
                        <FontAwesomeIcon icon="angle-right" />
                    </span>}
                </div>
            </>
        );
    }

    renderHeaderReportLink = (reportType, reportName, reportsAvailability) => {
        if (isNullOrUndefined(reportsAvailability[reportType]) || reportsAvailability[reportType] === false)
            return null;

        const showCreditInfo = this.shouldShowCreditInfo(reportType)
        const isActive = this.isActiveLink(`/report/${reportName}`);
        const isDataCorrection = reportType === reportTypes.dataCorrection || reportType === reportTypes.dataCorrectionInternal;

        return (
            <React.Fragment key={`report-header-link-${reportType}`}>
                <div className={classnames("tab-link", { "is-active": isActive, "hide-on-mobile": isDataCorrection })} style={TAB_STYLE}
                    ref={el => {
                        if (el && el.className.indexOf("is-active") !== -1)
                            this.activeLink = el;
                    }}
                >
                    <a className="report-selection-menu-link" style={{ borderBottom: "none", fontWeight: isActive ? "900" : "normal" }} onClick={showCreditInfo
                        ? () => this.onReportRequested(reportType, reportName)
                        : () => this.props.repiRedirect(this.getUrlForReport(reportName, false))}
                    >
                        <Translate id={`Repi.Report.${reportName}`} />
                    </a>
                    <div className="search-progress-short" style={{ display: isActive ? "" : "none" }}></div>
                </div>
            </React.Fragment>
        );
    }

    renderSearchLinks = () => {
        const lastSearchQuery = this.props.getLastSearchQuery();
        const searchUrl =  `/search${(this.isOnResultsPage || this.isOnReportPage ? lastSearchQuery : "")}`;
        const displaySearchResultsTab = !isEmpty(lastSearchQuery) || this.isOnResultsPage;

        return (
            <>
                <div className={classnames("tab-link", { "is-active" : this.isOnSearchPage, "faded": this.isOnReportPage })} style={TAB_STYLE}
                    ref={el => {
                        if (el && el.className.indexOf("is-active") !== -1)
                            this.activeLink = el;
                    }}
                >
                    <a className="report-selection-menu-link" style={{ borderBottom: "none" }} onClick={() => this.props.repiRedirect(searchUrl)}>
                        <Translate id="Search.Common.Search" />
                    </a>
                    <div className="search-progress-short" style={{ display: this.isOnSearchPage ? "" : "none" }}></div>
                </div>
                {displaySearchResultsTab && <div className={classnames("tab-link", { "is-active" : this.isOnSearchPage, "faded": this.isOnReportPage })} style={TAB_STYLE}
                    ref={el => {
                        if (el && el.className.indexOf("is-active") !== -1)
                            this.activeLink = el;
                    }}
                >
                    <a className="report-selection-menu-link" style={{ borderBottom: "none" }} onClick={() => this.props.repiRedirect(`/results${lastSearchQuery}`)}>
                        <Translate id="Search.Common.Results" />
                    </a>
                    <div className="search-progress-short" style={{ display: this.isOnResultsPage ? "" : "none" }}></div>
                </div>}
            </>
        );
    }

    renderRepiLogo = () => {
        const agentLanguage = !isNullOrUndefined(this.props.user.authentication.profile)
            ? this.props.user.authentication.profile.agentLanguage : getLanguage();

        switch (agentLanguage) {
            case "sk-SK": return <RepiSk />;
            case "cs-CZ": return <RepiCz />;
            default: return <RepiEn />;
        }
    }

    renderDotSlider = () => {
        return (
            <div className={classnames("report-selection-menu-line-wrapper hide-on-mobile is-repi", { "tinted": this.isTinted })} style={{ zIndex: 18 }}>
                {!this.props.report.isLoading && <hr className="report-selection-menu-line gradient-2" ref={el => this.handleHrRef(el)} />}
                {this.props.report.isLoading && <div className="search-report-progress-wrapper" style={{ margin: "0.4em 1em" }}>
                    <div className="search-progress searching" style={{ height: "0.1em" }}></div>
                </div>}
                <div
                    className="report-selection-menu-circle-wrapper"
                    style={{
                        left: (this.activeLink && this.repSelRef) ? `${this.activeLink.offsetLeft}px` : "",
                        width: (this.activeLink && this.repSelRef) ? `${this.activeLink.offsetWidth}px` : "",
                        top: "0px"
                    }}
                >
                    <div
                        className="report-selection-menu-circle gradient-2"
                        ref={el => this.handleCircleRef(el)}
                        style={{
                            backgroundPosition: (this.activeLink && this.circleEl) ?
                                `-${this.activeLink.offsetLeft + this.circleEl.offsetLeft}px` : "",
                            backgroundSize: this.hrEl ? `${this.hrEl.offsetWidth}px` : ""
                        }} />
                </div>
            </div>
        );
    }

    getUrlForReport = (reportName, withPrefix = true, calculationDate = null, forcedParams = null) => {
        const { subjectId } = this.props.getRepiProps();
        let params = getParams(window.location.search);

        if (!isPoolReport(reportName))
            params = omit(params, ["poolGroup"]);
        else if (isPoolReport(reportName) && this.repiSettings.takeFirstGroup && Object.keys(this.repiSettings.customerGroups).length > 0)
            params.poolGroup = Object.keys(this.repiSettings.customerGroups).sort()[0]

        if (!isNullOrUndefined(calculationDate))
            params.calculationDate = moment(calculationDate).format("YYYY-MM-DD");

        if (!isNullOrUndefined(forcedParams))
            params = { ...params, ...forcedParams };

        return `${(withPrefix ? this.props.match.url : "")}/report/${reportName}/${subjectId}?${new URLSearchParams(params)}`;
    }

    onReportRequested = (reportType, reportName, calculationDate = null) => {
        const isPool = isPoolReport(reportType);
        const { subjectId } = this.props.getRepiProps();
        const params = getParams(window.location.search);

        const requestParams = { sharedRegistry: isNullOrUndefined(params.sharedRegistry) ? false : params.sharedRegistry };
        if (!isNullOrUndefined(calculationDate))
            requestParams.calculationDate = moment(calculationDate).format("YYYY-MM-DD");

        if (isPool) {
            if (!isNullOrUndefined(params.poolGroup))
                requestParams.poolGroup = params.poolGroup;
            else {
                const groups = Object.keys(this.repiSettings.customerGroups);
                if (groups.length > 0)
                    requestParams.poolGroup = groups[0];
            }
        }

        const plusReportRequest = reportType === reportTypes.creditPlus
            || reportType === reportTypes.poolPlus && this.repiSettings.takeFirstGroup || reportType === reportTypes.invoicesPlus;

        apiGet(`${getHostApi()}/api/repi/report/${reportName}/${subjectId}/check`, requestParams,
            s => {
                if (isNullOrUndefined(s) || !s.hasData)
                    writeErr(`/api/repi/report/${reportName}/${subjectId}/check -- No data returned from API`);
                else if ((s.data === 0 && ((isPoolReport(reportType) && this.repiSettings.takeFirstGroup) || !isPoolReport(reportType)))
                    || isInvoicesReport(reportType, true)
                ) {
                    writeInfo(`/api/repi/report/${reportName}/${subjectId}/check -- Report is free`);
                    if (plusReportRequest && !this.hasConsent(params, subjectId) && !this.isPo()) {
                        this.props.showPopup("repiConsentPopup", {
                            open: true,
                            close: () => { this.props.hidePopup() },
                            onConfirm: () => {
                                addConsentToStorage(subjectId);
                                const searchParams = new URLSearchParams(isPoolReport(reportType) ? requestParams : omit(requestParams, ["poolGroup"]));
                                this.props.repiRedirect(`/report/${reportName}/${subjectId}?${searchParams}`);
                            },
                            reportName: this.props.translate(`Repi.Report.${capitalize(reportType)}`)
                        })
                    } else
                        this.props.repiRedirect(this.getUrlForReport(reportName, false, calculationDate));
                } else {
                    let defaultPoolGroup = null;
                    if (isPool) {
                        const paramsPool = parseInt(requestParams.poolGroup);
                        if (!isNaN(paramsPool) && Object.keys(this.repiSettings.customerGroups).reduce((a, c) => paramsPool === parseInt(c) || a, false))
                            defaultPoolGroup = paramsPool;
                        else if (Object.keys(this.repiSettings.customerGroups).length > 0)
                            defaultPoolGroup = parseInt(Object.keys(this.repiSettings.customerGroups).sort()[0]);
                    }
                    this.props.showPopup("repiReportCreditConfirmationPopup", {
                        title: this.props.translate("Common.Warning"),
                        open: true,
                        reportName: reportName,
                        reportType: reportType,
                        requestParams: requestParams,
                        price: s.data,
                        error: s.error,
                        consent: this.isPo() ? true : this.hasConsent(params, subjectId),
                        isPo: this.isPo(),
                        close: isNullOrUndefined(s.error) ? undefined : () => this.props.hidePopup(),
                        no: () => this.props.hidePopup(),
                        yes: (consent, poolGroup) => {
                            if (consent)
                                addConsentToStorage(subjectId);
                            if (!isNullOrUndefined(poolGroup))
                                requestParams.poolGroup = poolGroup;
                            const searchParams = new URLSearchParams(isPoolReport(reportType) ? requestParams : omit(requestParams, ["poolGroup"]));
                            this.props.repiRedirect(`/report/${reportName}/${subjectId}?${searchParams}`);
                        },
                        pool: {
                            allowSelection: !this.repiSettings.takeFirstGroup,
                            groups: isPool ? this.repiSettings.customerGroups : null,
                            defaultGroup: defaultPoolGroup
                        },
                    });
                }
            },
            e => writeErr(e)
        );
    }

    isActiveLink = (item) => {
        if (isNullOrUndefined(this.props.location) || !isString(this.props.location.pathname) || !isString(item))
            return false;

        return this.props.location.pathname.toLowerCase().indexOf(item.toLowerCase()) >= 0;
    }

    shouldShowCreditInfo = (reportType) => {
        if (!isString(reportType))
            return false;

        return [
            reportTypes.subjectPlus,
            reportTypes.invoicesMinus,
            reportTypes.dataCorrection,
            reportTypes.dataCorrectionInternal
        ].reduce((a, c) => c.toLowerCase() !== reportType.toLowerCase() && a, true);
    }

    handleHrRef = (el) => {
        if (isNullOrUndefined(el) || this.hrEl === el)
            return;
        this.hrEl = el;
        this.resolveDot();
    }

    handleCircleRef = (el) => {
        if (isNullOrUndefined(el) || this.circleEl === el)
            return;
        this.circleEl = el;
        this.resolveDot();
    }

    linkRef = (el) => {
        if (isNullOrUndefined(el) || this.repSelRef === el)
            return;
        this.repSelRef = el;
        this.solveControls();
    }

    handleWindowResize = (e) => {
        this.solveControls();
        this.resolveDot();
    }

    solveControls = () => {
        if (isNullOrUndefined(this.repSelRef))
            return;

            //this +2 is because of IE defect
        const hasControls = ((this.repSelRef.scrollWidth > this.repSelRef.offsetWidth) && (this.repSelRef.scrollWidth > this.repSelRef.offsetWidth + 2));
        if (this.state.hasControls != hasControls)
            this.setState({ hasControls })
    }

    resolveDot = () => {
        const dotOffsetLeft = ((this.activeLink || {}).offsetLeft || 0) + ((this.circleEl || {}).offsetLeft || 0);
        if (dotOffsetLeft !== this.state.dotOffsetLeft) {
            this.setState({ dotOffsetLeft });
        }
    }

    scroll = (event, dir) => {
        event.preventDefault();
        const min = 0;
        const max = this.repSelRef.scrollWidth - this.repSelRef.offsetWidth;
        const shift = this.repSelRef.offsetWidth / 2;
        const movePos = (dir === "left") ? Math.max(min, this.state.movePos - shift) : Math.min(max, this.state.movePos + shift);

        if (this.repSelRef.scrollTo) {
            this.repSelRef.scrollTo({ left: movePos, behavior: "smooth" });
        } else {
            this.repSelRef.scrollLeft = movePos;
        }
        this.setState({ movePos, isBeginPos: movePos === min, isEndPos: movePos === max });
    }

    isPo = () => {
        if (isNullOrUndefined(this.props.report) || isNullOrUndefined(this.props.report.sections) || !Array.isArray(this.props.report.sections))
            return false;

        const ident = this.props.report.sections.find(f => f.id === SECTIONS.repiReportIdentification);
        return (isNullOrUndefined(ident) || isNullOrUndefined(ident.data))
            ? false : ident.data.subjectType === 3;
    }

    hasConsent = (params, subjectId) => this.props.search.consent === true || (params.consent || "").toString() === "true"
        || hasConsentInStorage(subjectId);

    isReport = (type) => this.props.location.search.indexOf("type=" + type) >= 0;
}

export default withRouter(withLocalize(connect(
    state => ({
        search: state.repi.search,
        repiSettings: state.repi.settings,
        layout: state.layout,
        report: state.report,
        user: state.userContext
    }),
    dispatch => bindActionCreators({ ...repiActions, ...reportActions, ...popupActions }, dispatch)
)(RepiHeader)));